import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlueprintCleaningMethod, LazyBlueprintMagazineArticle, LazyBlueprintMedia, LazyBlueprintPage, LazyHeroHeroModule, LazyHeroMagazineArticle, LazyHeroProduct, LazyHeroStandard, LazyComponentHeroModule, LazyCustomHtml, LazyDownloadcenter, LazyFacts, LazyFormContact, LazyFormCustom, LazyHighlights, LazyImageGallery, LazyImageWithText, LazyImageWithTextSimple, LazyInteractive360Approach, LazyListing, LazyLocationsFinder, LazyNewsletter, LazyOverviewCleaningMethods, LazyOverviewMagazine, LazyOverviewTeam, LazyProcess, LazyQuickAccess, LazyQuote, LazyTable, LazyTeaserCleaningMethods, LazyTeaserFlexible, LazyTeaserMagazine, LazyTeaserProducts, LazyTeaserTeamMember, LazyText, LazyTextTwoColumns, LazyVideo, LazyIconArrowLeft, LazyIconArrowRight, LazyIconArrowUpRight, LazyIconCheck, LazyIconCheckbox, LazyIconChevron, LazyIconClose, LazyIconDownload, LazyIconFilter, LazyIconHouse, LazyIconLanguage, LazyIconLinkedin, LazyIconLoad, LazyIconLocationMarker, LazyIconMagnifyingGlass, LazyIconMail, LazyIconMenu, LazyIconMinus, LazyIconPhone, LazyIconPlay, LazyIconPlus, LazyIconSearch, LazyIconSpin, LazyIconUpload, LazyIconWetrokLogo, LazyIconYoutube, LazyAppButton, LazyAppImage, LazyContainer, LazyContentSection } from '#components'
const lazyGlobalComponents = [
  ["BlueprintCleaningMethod", LazyBlueprintCleaningMethod],
["BlueprintMagazineArticle", LazyBlueprintMagazineArticle],
["BlueprintMedia", LazyBlueprintMedia],
["BlueprintPage", LazyBlueprintPage],
["HeroHeroModule", LazyHeroHeroModule],
["HeroMagazineArticle", LazyHeroMagazineArticle],
["HeroProduct", LazyHeroProduct],
["HeroStandard", LazyHeroStandard],
["ComponentHeroModule", LazyComponentHeroModule],
["CustomHtml", LazyCustomHtml],
["Downloadcenter", LazyDownloadcenter],
["Facts", LazyFacts],
["FormContact", LazyFormContact],
["FormCustom", LazyFormCustom],
["Highlights", LazyHighlights],
["ImageGallery", LazyImageGallery],
["ImageWithText", LazyImageWithText],
["ImageWithTextSimple", LazyImageWithTextSimple],
["Interactive360Approach", LazyInteractive360Approach],
["Listing", LazyListing],
["LocationsFinder", LazyLocationsFinder],
["Newsletter", LazyNewsletter],
["OverviewCleaningMethods", LazyOverviewCleaningMethods],
["OverviewMagazine", LazyOverviewMagazine],
["OverviewTeam", LazyOverviewTeam],
["Process", LazyProcess],
["QuickAccess", LazyQuickAccess],
["Quote", LazyQuote],
["Table", LazyTable],
["TeaserCleaningMethods", LazyTeaserCleaningMethods],
["TeaserFlexible", LazyTeaserFlexible],
["TeaserMagazine", LazyTeaserMagazine],
["TeaserProducts", LazyTeaserProducts],
["TeaserTeamMember", LazyTeaserTeamMember],
["Text", LazyText],
["TextTwoColumns", LazyTextTwoColumns],
["Video", LazyVideo],
["IconArrowLeft", LazyIconArrowLeft],
["IconArrowRight", LazyIconArrowRight],
["IconArrowUpRight", LazyIconArrowUpRight],
["IconCheck", LazyIconCheck],
["IconCheckbox", LazyIconCheckbox],
["IconChevron", LazyIconChevron],
["IconClose", LazyIconClose],
["IconDownload", LazyIconDownload],
["IconFilter", LazyIconFilter],
["IconHouse", LazyIconHouse],
["IconLanguage", LazyIconLanguage],
["IconLinkedin", LazyIconLinkedin],
["IconLoad", LazyIconLoad],
["IconLocationMarker", LazyIconLocationMarker],
["IconMagnifyingGlass", LazyIconMagnifyingGlass],
["IconMail", LazyIconMail],
["IconMenu", LazyIconMenu],
["IconMinus", LazyIconMinus],
["IconPhone", LazyIconPhone],
["IconPlay", LazyIconPlay],
["IconPlus", LazyIconPlus],
["IconSearch", LazyIconSearch],
["IconSpin", LazyIconSpin],
["IconUpload", LazyIconUpload],
["IconWetrokLogo", LazyIconWetrokLogo],
["IconYoutube", LazyIconYoutube],
["AppButton", LazyAppButton],
["AppImage", LazyAppImage],
["Container", LazyContainer],
["ContentSection", LazyContentSection],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
